/**
 * BariBowl Theme JS
 * Cart drawer · Mobile nav · Add-to-cart · PDP variant switching · Filter drawer · Qty steppers
 */

(function () {
  'use strict';

  /* ─── Utility ────────────────────────────────────────────────────── */

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    return window.__bb && window.__bb.currency
      ? (cents / 100).toLocaleString('en-US', { style: 'currency', currency: window.__bb.currency })
      : '$' + (cents / 100).toFixed(2);
  }

  /* ─── Cart State ───────────────────────────────────────────────────── */

  var cartState = { items: [], item_count: 0, total_price: 0 };

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartState = cart;
        updateCartBadge(cart.item_count);
        updateShippingBar(cart.total_price);
        return cart;
      });
  }

  function addToCart(variantId, qty, onSuccess) {
    qty = qty || 1;
    var btn = qs('[data-variant-id="' + variantId + '"]');
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Add failed');
        return r.json();
      })
      .then(function () {
        return fetchCart();
      })
      .then(function (cart) {
        renderCartItems(cart);
        openCartDrawer();
        if (btn) { btn.disabled = false; btn.textContent = 'Add'; }
        if (onSuccess) onSuccess(cart);
      })
      .catch(function (err) {
        console.error('Add to cart error:', err);
        if (btn) { btn.disabled = false; btn.textContent = 'Add'; }
      });
  }

  function updateCartItem(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartState = cart;
        updateCartBadge(cart.item_count);
        updateShippingBar(cart.total_price);
        renderCartItems(cart);
      });
  }

  /* ─── Cart Badge ───────────────────────────────────────────────────── */

  function updateCartBadge(count) {
    qsa('#cartBadge').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  /* ─── Shipping Bar ─────────────────────────────────────────────────── */

  function updateShippingBar(totalCents) {
    var threshold = (window.__bb && window.__bb.free_shipping_threshold) || 5000;
    var msg = qs('#shippingMsg');
    var fill = qs('#shippingFill');
    if (!msg || !fill) return;

    if (totalCents >= threshold) {
      msg.innerHTML = '🎉 You\'ve unlocked <strong>free shipping!</strong>';
      fill.style.width = '100%';
    } else {
      var remaining = ((threshold - totalCents) / 100).toFixed(2);
      msg.innerHTML = '<strong>$' + remaining + '</strong> away from free shipping';
      fill.style.width = Math.min((totalCents / threshold) * 100, 100) + '%';
    }
  }

  /* ─── Cart Drawer Render ──────────────────────────────────────────── */

  function renderCartItems(cart) {
    var wrap = qs('#cartItemsWrap');
    if (!wrap) return;

    // Item count chip
    var countEl = qs('#drawerItemCount');
    if (countEl) countEl.textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' items');

    // Subtotal / total
    var subtotalEl = qs('#cartSubtotal');
    var totalEl = qs('#cartTotal');
    var checkoutEl = qs('#checkoutTotal');
    var price = formatMoney(cart.total_price);
    if (subtotalEl) subtotalEl.textContent = price;
    if (totalEl) totalEl.textContent = price;
    if (checkoutEl) checkoutEl.textContent = 'Checkout · ' + price;

    if (cart.items.length === 0) {
      wrap.innerHTML = '<p style="font-family:var(--font-sans);font-size:15px;color:var(--color-stone);text-align:center;padding:48px 0;">Your bag is empty.</p>';
      return;
    }

    wrap.innerHTML = cart.items.map(function (item) {
      return '<div class="cart-item" data-key="' + item.key + '">' +
        '<div class="cart-item-img">' +
          (item.image
            ? '<img src="' + item.image + '" alt="' + escapeHtml(item.title) + '" width="72" height="72" style="width:100%;height:100%;object-fit:contain;">'
            : '') +
        '</div>' +
        '<div class="cart-item-info">' +
          '<p class="cart-item-title">' + escapeHtml(item.product_title) + '</p>' +
          (item.variant_title && item.variant_title !== 'Default Title'
            ? '<p class="cart-item-variant">' + escapeHtml(item.variant_title) + '</p>'
            : '') +
          '<div class="qty-stepper" style="margin-top:8px;" role="group" aria-label="Quantity for ' + escapeHtml(item.product_title) + '">' +
            '<button type="button" class="qty-btn" aria-label="Decrease" data-action="decrease" data-key="' + item.key + '">−</button>' +
            '<span class="qty-input" aria-live="polite" style="display:flex;align-items:center;justify-content:center;min-width:32px;font-family:var(--font-mono);font-size:14px;">' + item.quantity + '</span>' +
            '<button type="button" class="qty-btn" aria-label="Increase" data-action="increase" data-key="' + item.key + '">+</button>' +
          '</div>' +
        '</div>' +
        '<div style="display:flex;flex-direction:column;align-items:flex-end;justify-content:space-between;">' +
          '<span class="cart-item-price">' + formatMoney(item.final_line_price) + '</span>' +
          '<button type="button" class="cart-item-remove" data-key="' + item.key + '" aria-label="Remove ' + escapeHtml(item.product_title) + '">Remove</button>' +
        '</div>' +
      '</div>';
    }).join('');
  }

  function escapeHtml(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ─── Cart Drawer Open / Close ─────────────────────────────────────── */

  function openCartDrawer() {
    var drawer = qs('#cartDrawer');
    var scrim = qs('#cartScrim');
    var toggle = qs('#cartToggle');
    if (!drawer) return;
    drawer.classList.add('cart-drawer--open');
    if (scrim) scrim.classList.add('cart-drawer-scrim--visible');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    drawer.removeAttribute('aria-hidden');
    var close = qs('#cartClose', drawer);
    if (close) close.focus();
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    var drawer = qs('#cartDrawer');
    var scrim = qs('#cartScrim');
    var toggle = qs('#cartToggle');
    if (!drawer) return;
    drawer.classList.remove('cart-drawer--open');
    if (scrim) scrim.classList.remove('cart-drawer-scrim--visible');
    if (toggle) { toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); }
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* ─── Mobile Nav ───────────────────────────────────────────────── */

  function initMobileNav() {
    var toggle = qs('#mobileNavToggle');
    var menu = qs('#mobileNavMenu');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', function () {
      var open = menu.getAttribute('aria-hidden') === 'false';
      menu.setAttribute('aria-hidden', open ? 'true' : 'false');
      menu.style.display = open ? 'none' : 'block';
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      toggle.setAttribute('aria-label', open ? 'Open menu' : 'Close menu');
    });
  }

  /* ─── PDP — Accordion toggle (plus rotates 45° → ×) ────────────────── */

  window.pdpExpanderToggle = function (btn) {
    var expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    var body = btn.nextElementSibling;
    if (body) body.classList.toggle('open', !expanded);
  };

  /* ─── PDP — Thumbnail switcher ────────────────────────────────────── */

  window.pdpThumbClick = function (btn) {
    var main = qs('#pdpMainImgEl');
    if (!main) return;
    main.src = btn.dataset.src;
    main.alt = btn.dataset.alt;
    qsa('.pdp-thumb').forEach(function (t) { t.classList.remove('pdp-thumb--active'); });
    btn.classList.add('pdp-thumb--active');
  };

  /* ─── PDP — Qty stepper ────────────────────────────────────────────── */

  window.pdpQtyChange = function (btn, delta) {
    var input = qs('#pdpQty');
    if (!input) return;
    var val = Math.max(1, parseInt(input.value, 10) + delta);
    input.value = val;
  };

  /* ─── PDP — Option / variant selection ────────────────────────────── */

  window.pdpSelectOption = function (btn, value, optionIndex) {
    // Update pressed state for sibling swatches / pills / variant cards
    var parent = btn.closest('.pdp-variant-cards') || btn.closest('div');
    qsa('.pdp-swatch, .pdp-option-pill, .pdp-variant-card', parent).forEach(function (el) {
      el.classList.remove('color-swatch-btn--active', 'pdp-option-pill--active', 'pdp-variant-card--active');
      el.setAttribute('aria-pressed', 'false');
    });
    if (btn.classList.contains('pdp-swatch')) {
      btn.classList.add('color-swatch-btn--active');
    } else if (btn.classList.contains('pdp-variant-card')) {
      btn.classList.add('pdp-variant-card--active');
    } else {
      btn.classList.add('pdp-option-pill--active');
    }
    btn.setAttribute('aria-pressed', 'true');
    // Update the label that shows selected value (e.g. "Pack size   3-Pack").
    // Colour options render #selectedColor{n}; other options render #selectedVariant{n}.
    var labelEl = qs('#selectedVariant' + (optionIndex + 1)) || qs('#selectedColor' + (optionIndex + 1));
    if (labelEl) labelEl.textContent = value;

    // Update the hidden select to trigger native Shopify variant resolution
    var select = qs('#pdpVariantSelect');
    if (!select) return;

    var productJSON = qs('#pdpProductJSON');
    if (!productJSON) return;
    var product;
    try { product = JSON.parse(productJSON.textContent); } catch (e) { return; }

    // Build current selected options array
    var options = [];
    qsa('[data-option-index]').forEach(function (el) {
      var idx = parseInt(el.dataset.optionIndex, 10);
      if (el.getAttribute('aria-pressed') === 'true') {
        options[idx] = el.dataset.value;
      }
    });

    // Override the clicked option
    options[optionIndex] = value;

    // Find matching variant
    var match = product.variants.find(function (v) {
      return v.options.every(function (opt, i) { return !options[i] || opt === options[i]; });
    });

    if (match) {
      // Update price
      var priceEl = qs('#pdpPrice');
      var wasEl = qs('#pdpPriceWas');
      if (priceEl) {
        priceEl.textContent = (match.price_varies ? 'From ' : '') + formatMoney(match.price);
      }
      if (wasEl) {
        wasEl.textContent = match.compare_at_price > match.price ? formatMoney(match.compare_at_price) : '';
        wasEl.style.display = match.compare_at_price > match.price ? '' : 'none';
      }
      // Update select value and ATC button
      select.value = match.id;
      var atcBtn = qs('#pdpAtcBtn');
      if (atcBtn) {
        if (match.available) {
          atcBtn.disabled = false;
          atcBtn.removeAttribute('aria-disabled');
          atcBtn.textContent = 'Add to cart · ' + formatMoney(match.price);
        } else {
          atcBtn.disabled = true;
          atcBtn.setAttribute('aria-disabled', 'true');
          atcBtn.textContent = 'Sold out';
        }
      }
    }
  };

  window.pdpVariantChanged = function (select) {
    // Sync ATC button with hidden select changes
    var option = select.options[select.selectedIndex];
    var atcBtn = qs('#pdpAtcBtn');
    if (atcBtn) {
      atcBtn.disabled = option.disabled;
    }
  };

  /* ─── PDP — Add to cart form ───────────────────────────────────────── */

  function initPDPForm() {
    var form = qs('[data-type="add-to-cart-form"]');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var variantId = (qs('#pdpVariantSelect', form) || qs('[name="id"]', form)).value;
      var qty = parseInt((qs('#pdpQty', form) || { value: '1' }).value, 10) || 1;
      var btn = qs('[name="add"]', form);
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { return fetchCart(); })
        .then(function (cart) {
          renderCartItems(cart);
          openCartDrawer();
          if (btn) { btn.disabled = false; btn.textContent = 'Add to cart'; }
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = 'Add to cart'; }
        });
    });
  }

  /* ─── Product card Add buttons ─────────────────────────────────────── */

  function initCardAddButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-variant-id][data-product-id]');
      if (!btn || btn.type === 'submit') return;
      e.preventDefault();
      var variantId = btn.dataset.variantId;
      if (!variantId) return;
      addToCart(variantId, 1);
    });
  }

  /* ─── Cart Drawer qty steppers (delegated) ─────────────────────────── */

  function initCartDelegation() {
    var drawer = qs('#cartDrawer');
    if (!drawer) return;

    drawer.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('.qty-btn[data-key]');
      if (qtyBtn) {
        var key = qtyBtn.dataset.key;
        var action = qtyBtn.dataset.action;
        var span = qtyBtn.closest('.qty-stepper').querySelector('.qty-input');
        var current = parseInt(span ? span.textContent : '1', 10);
        var newQty = action === 'increase' ? current + 1 : Math.max(0, current - 1);
        updateCartItem(key, newQty);
        return;
      }

      var removeBtn = e.target.closest('.cart-item-remove');
      if (removeBtn) {
        updateCartItem(removeBtn.dataset.key, 0);
      }
    });
  }

  /* ─── Cart toggle ──────────────────────────────────────────────────── */

  function initCartToggle() {
    var toggle = qs('#cartToggle');
    var closeBtn = qs('#cartClose');
    var scrim = qs('#cartScrim');

    if (toggle) {
      toggle.addEventListener('click', function () {
        var drawer = qs('#cartDrawer');
        if (drawer && drawer.classList.contains('cart-drawer--open')) {
          closeCartDrawer();
        } else {
          fetchCart().then(function (cart) { renderCartItems(cart); openCartDrawer(); });
        }
      });
    }

    if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
    if (scrim) scrim.addEventListener('click', closeCartDrawer);

    // Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCartDrawer();
    });
  }

  /* ─── Filter drawer (mobile PLP) ──────────────────────────────────── */

  function initFilterDrawer() {
    var toggle = qs('#filterDrawerToggle');
    var drawer = qs('#filterDrawer');
    var closeBtn = qs('#filterDrawerClose');
    var scrim = qs('#filterScrim');
    if (!toggle || !drawer) return;

    function openFilter() {
      drawer.setAttribute('aria-hidden', 'false');
      scrim && scrim.classList.add('cart-drawer-scrim--visible');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      closeBtn && closeBtn.focus();
    }

    function closeFilter() {
      drawer.setAttribute('aria-hidden', 'true');
      scrim && scrim.classList.remove('cart-drawer-scrim--visible');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      toggle.focus();
    }

    toggle.addEventListener('click', openFilter);
    if (closeBtn) closeBtn.addEventListener('click', closeFilter);
    if (scrim) scrim.addEventListener('click', closeFilter);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeFilter(); });
  }

  /* ─── Filter group toggles ─────────────────────────────────────────── */

  function initFilterGroups() {
    qsa('.filter-group-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        var body = qs('#' + btn.getAttribute('aria-controls'));
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (body) body.style.display = open ? 'none' : '';
        var chevron = btn.querySelector('.filter-chevron');
        if (chevron) chevron.style.transform = open ? 'rotate(0deg)' : 'rotate(180deg)';
      });
    });
  }

  /* ─── Color filter toggle helper ──────────────────────────────────── */

  window.toggleColorFilter = function (tag) {
    var form = qs('#filterForm');
    if (!form) return;
    var existing = form.querySelector('input[name="tag[]"][value="' + tag + '"]');
    if (existing) {
      existing.remove();
    } else {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'tag[]';
      input.value = tag;
      form.appendChild(input);
    }
    // Toggle visual
    var btn = qs('[data-color-tag="' + tag + '"]');
    if (btn) {
      var active = btn.getAttribute('aria-pressed') === 'true';
      btn.setAttribute('aria-pressed', active ? 'false' : 'true');
      btn.classList.toggle('color-swatch-btn--active', !active);
    }
    form.submit();
  };

  /* ─── Announcement bar dismiss ─────────────────────────────────────── */

  function initAnnouncementDismiss() {
    var bar = qs('#announcementBar');
    var dismissBtn = qs('#announcementDismiss');
    if (!dismissBtn || !bar) return;
    dismissBtn.addEventListener('click', function () {
      bar.style.display = 'none';
      try { sessionStorage.setItem('bb_announcement_dismissed', '1'); } catch (e) {}
    });
    try {
      if (sessionStorage.getItem('bb_announcement_dismissed')) bar.style.display = 'none';
    } catch (e) {}
  }

  /* ─── Init ─────────────────────────────────────────────────────────── */

  function _bbInit() {
    fetchCart();
    initCartToggle();
    initCartDelegation();
    initCardAddButtons();
    initMobileNav();
    initPDPForm();
    initFilterDrawer();
    initFilterGroups();
    initAnnouncementDismiss();

    // Accordion — delegated click (no dependency on inline onclick)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.pdp-expander-btn');
      if (!btn) return;
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      var body = btn.nextElementSibling;
      if (body) body.classList.toggle('open', !expanded);
    });
  }

  // Works whether script is defer-loaded (DOM already ready) or inline
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', _bbInit);
  } else {
    _bbInit();
  }

  // Expose for Liquid-rendered inline usage
  window.bbCart = { open: openCartDrawer, close: closeCartDrawer, addToCart: addToCart };

})();
